"use client";

import { useCallback } from "react";

import {
  useVariableContext,
  VariableMenu,
} from "@/features/ai-prompts/components/variable";
import type { VariableDefinition } from "@/features/ai-prompts/lib/variable-catalog";

import type { InsertionTarget } from "./types";

interface VariablesPanelProps {
  onInsert: (target: InsertionTarget) => void;
  onClose: () => void;
}

/**
 * Standalone variables popover. Wraps the shared `VariableMenu` (cmdk-backed
 * search + grouped catalog) so the variables button opens variables only.
 */
export function VariablesPanel({ onInsert, onClose }: VariablesPanelProps) {
  const { allowBlockEnrollment } = useVariableContext();

  const handleInsert = useCallback(
    (definition: VariableDefinition) => {
      const fallbackPolicy =
        !allowBlockEnrollment &&
        definition.default_fallback === "block_enrollment"
          ? "literal_fallback"
          : definition.default_fallback;
      onInsert({
        kind: "variable",
        attrs: {
          key: definition.key,
          category: definition.category,
          label: definition.label,
          fallback_policy: fallbackPolicy,
          fallback_literal: definition.default_literal,
        },
      });
    },
    [allowBlockEnrollment, onInsert],
  );

  return (
    <VariableMenu
      onInsert={handleInsert}
      onClose={onClose}
      className="w-[360px]"
    />
  );
}
